module.exports = __webpack_public_path__ + "img/202505_04.5742792f.jpg";